import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSnackbarSuccess, MandatoryStar } from "../../../Utils/helper";
import { GetAppointmentInsurerAction, RevertPayoutInsurerApprovalIBU } from "../../../redux/actions/PayoutAction";

export const RevertMode = ({
  searchFilter,
  setIsRevert,
  isRevert,
  rowData
}) => {
  const ref = useRef();
  const [remark, setRemark] = useState(null);
  const dispatch = useDispatch();
  console.log(isRevert)
  // const insBillReducer = useSelector((state) => state?.InsBillingPayout?.insRemarks);

  // useEffect(()=>{
  //   const rem = insBillReducer?.filter((ele)=>{
  //     if(ele?.appointmentId === providerDetail[0]?.appointmentId && ele?.remarksType === "Remove" ){
  //       return ele
  //     }
  //   })
  //   setRemark(rem[0]?.remarks)
  // },[providerDetail])
  console.log(rowData)
  const handleSubmit = async (event) => {
    event.preventDefault();
    event.target.className += " was-validated";
    if (event.target.checkValidity()) {
      const res = await dispatch(
        RevertPayoutInsurerApprovalIBU({
          CaseNo:isRevert?.data?.caseNo,
          remarks: remark,
          year: isRevert?.data?.year,
          month: isRevert?.data?.month,
        })
      );
      if (res) {
        getSnackbarSuccess("success", res?.data?.message, dispatch);
        dispatch(
          GetAppointmentInsurerAction({
          ...searchFilter,
          sessionId: rowData?.sessionId,
          ticketId: rowData?.requestID,
          providerId: null,
          clientId:rowData?.clientId
        })
      );
        handleClose();
      }
    }
  };

  const handleClose = () => {
    setIsRevert({data:null,open:false})
 
  };
  return (
    <>
      <div
        className="d-flex justify-content-between border-bottom modalHeader"
        style={{ borderRadius: "10px 10px 0px 0px" }}
      >
        <h4 className="font-bold text-black ">Revert Appointments</h4>
        <button
          type="button"
          className="btn-close history-close"
          aria-label="Close"
          onClick={() => handleClose()}
        ></button>
      </div>

      <form
        ref={ref}
        className="form-admin"
        style={{ overflowX: "hidden" }}
        onSubmit={handleSubmit}
        noValidate
      >
        <div className="modal-body addusermodalbox">
          <div className="row">
            <div className="col-lg-12 col-md-12 mt-2">
                {/* <div style={{fontWeight:"600"}}>Case Number : {providerDetail[0]?.caseNo}</div> */}
              <label className="col-form-label">
                Remarks
                <MandatoryStar />
              </label>
              <textarea
                required
                className="form-control form-select-admin inputbgavanish"
                rows="5"
                cols="33"
                value={remark}
                onKeyPress={(e) => {
                  const re = /^[a-zA-Z\s]*$/;
                  if (e.target.value.trim() === "" && e.key === " ") {
                    e.preventDefault();
                    return;
                  }
                }}
                onChange={(e) => setRemark(e.target.value)}
              ></textarea>
            </div>
          </div>
        </div>

        <div className="modal-footer modal-footer-admin  bottom-0  mt-4">
          <div className="d-flex justify-content-end flex-wrap gap-10">
            <button
              onClick={() => handleClose()}
              type="btn"
              className="savedetails"
            >
              Cancel
            </button>
            <button type="submit" className="savedetails">
              {"Update"}
            </button>
          </div>
        </div>
      </form>
    </>
  );
};
